import cx from 'classnames'
import styles from './DashboardReminder.css'
import { HyperLink } from '../Common/Form'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const DASHBOARD_DATA_DEFINITION_URI = `${CDN}/supplier/Supplier-Dashboard-Data-Definition-202309.pdf`
const DASHBOARD_FEATURE_URI = `${CDN}/supplier/Supplier_Dashboard_202309.pdf`
const DashboardReminder = props => {
  const {
    className
  } = props
  const clz = cx(
    styles.DashboardReminder,
    {
      [className]: className
    }
  )

  return (
    <div className={clz}>
      <p><b>營運看板小提醒：</b></p>
      <p>
        * 瀏覽量(PV)、熱門關鍵字等數據自 2026/01/13(含)起，改由
        <b>Google Analytics (GA)</b>
        提供。
      </p>
      <p>* 2026/01/13 以前的瀏覽量數據，將維持來自原有的 Yahoo 內部系統統計。</p>
      <p>
        * 顯示之訂購金額皆為
        <b>訂購成本</b>
        ，包含業績排名之計算基礎、銷售概況揭露之訂購金額、品牌分析第一層/品牌分佈之統計來源。
      </p>
      <p>
        * 訂單成立之計算時機為
        <b>訂購日</b>
        ，即買家訂購成功之訂單。
      </p>
      <p>
        * 詳細指標說明，請看
        <HyperLink
          target='_blank'
          href={DASHBOARD_DATA_DEFINITION_URI}
        >
          這裡
        </HyperLink>
        。
      </p>
      <p>
        * 營運看板功能說明，請看
        <HyperLink
          target='_blank'
          href={DASHBOARD_FEATURE_URI}
        >
          這裡
        </HyperLink>
        。
      </p>
    </div>
  )
}

export default DashboardReminder
